import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import React from 'react';

interface TokenProtectedRouteProps {
    children: React.ReactNode;
    routeName: string; // use this to limit the token to a specific route.
}

const TokenProtectedRoute = ({ children, routeName }: TokenProtectedRouteProps) => {
    const [searchParams] = useSearchParams();
    const [authorized, setAuthorized] = useState<boolean | null>(null);

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setAuthorized(false);
            return;
        }

        axios
            .get('settings/authorizeToken?token='+token+'&routeName='+routeName)
            .then(res => {
                setAuthorized(res.data.valid);
            })
            .catch(() => setAuthorized(false));
    }, [searchParams, routeName]);

    if (authorized === null) return null;
    if (!authorized) return null;

    return <>{children}</>;
};

export default TokenProtectedRoute;